export const frontmatter = {"title":"Theme Editor"};
export const toc = [];